import React, { Dispatch, SetStateAction } from 'react';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Switch, SwitchProps, Box, Typography } from '@mui/material';
import { buzzerDetailsStyles } from './style';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

interface BuzzerDetailsProps {
  setBuzzer: Dispatch<SetStateAction<number | undefined>>;
  setSoundBuzzer: Dispatch<SetStateAction<number>>;
  soundBuzzer: number;
}

interface BuzzerOptionsProps {
  soundBuzzer: number;
}

const BuzzerOptions = styled(({ soundBuzzer, ...props }: BuzzerOptionsProps & SwitchProps) => <Switch {...props} />)(
  ({ theme, soundBuzzer }) => ({
    width: 78,
    height: 34,
    padding: 6,
    '& .MuiSwitch-switchBase': {
      display: 'flex',
      justifyContent: 'center',

      padding: 9,
      '&::hover': {},
      color: theme.palette.mainControls?.mainBlue,
      '&.Mui-checked': {
        transform: 'translateX(26px)',
        '& .MuiSwitch-thumb': {
          backgroundColor: soundBuzzer !== 0 ? theme.palette.mainControls?.mainBlue : '#D2D4D5',
          '&::before': {
            content: '"10s"',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: theme.palette.neutral?.white,
            fontSize: 12,
          },
        },
      },
      '& .MuiSwitch-thumb': {
        backgroundColor: soundBuzzer !== 0 ? theme.palette.mainControls?.mainBlue : '#D2D4D5',
        '&::before': {
          content: '"5s"',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: theme.palette.neutral?.white,
          fontSize: 12,
        },
      },
    },
    '& .MuiSwitch-thumb': {
      width: 34,
      height: 16,
      borderRadius: 8,
      position: 'relative',
    },
    '& .MuiSwitch-track': {
      border: `1px solid ${theme.palette.mainControls?.mainBlue}`,
      borderRadius: 34 / 2,
      position: 'relative',
      backgroundColor: `${theme.palette.mainControls?.lightGrey} !important`,
      '&::before, &::after': {
        content: 'attr(data-left)',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: 16,
        height: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 12,
        color: theme.palette.mainControls?.activeText,
      },
      '&::before': {
        left: 8,
        content: '"5s"',
      },
      '&::after': {
        right: 8,
        content: '"10s"',
      },
    },
  })
);

export const BuzzerDetails = (props: BuzzerDetailsProps) => {
  const { setBuzzer, setSoundBuzzer, soundBuzzer } = props;
  const { buzzerDetails } = buzzerDetailsStyles;
  const { t } = useTranslation();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.checked ? 10 : 5;
    setBuzzer(value);
    setSoundBuzzer(value);
  };

  return (
    <FormControl sx={buzzerDetails} component="fieldset" variant="standard">
      <FormGroup>
        <Box display="flex" alignItems="center">
          <FormControlLabel
            labelPlacement="start"
            label={
              <Typography className={`label ${soundBuzzer !== 0 ? '' : 'active-label'}`}>{t('zoomer')}</Typography>
            }
            control={
              <BuzzerOptions
                soundBuzzer={soundBuzzer}
                disabled={soundBuzzer !== 5 && soundBuzzer !== 10}
                onChange={handleChange}
              />
            }
          />
        </Box>
      </FormGroup>
    </FormControl>
  );
};
